<template>
  <v-card elevation="0">
    <v-card-subtitle>
      Параметры подключения к конечному серверу
    </v-card-subtitle>
    <v-card-text>
      <div class="d-flex align-center justify-center" style="width: 100%">      
        <v-menu
          close-on-click
        >
          <template #activator="{ on, attrs}">
            <v-btn
              color="green"
              dark
              v-bind="attrs"
              v-on="on"
              class="mr-2"
            >
              <v-icon>mdi-menu-down</v-icon>
              {{config.protocol}}
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="config.protocol = 'http'">
              <v-list-item-title>HTTP</v-list-item-title>
            </v-list-item>
            <v-list-item @click="config.protocol = 'https'">
              <v-list-item-title>HTTPS</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        ://
        <v-text-field 
          class="mx-2"
          style="flex: 10"
          label="Хост"
          color="green"
          v-model="config.host"
        />
        :
        <v-text-field 
          class="ml-2"
          style="flex: 3"
          label="Порт"
          :messages="['0 - порт по-умолчанию']"
          color="green"
          type="number"
          v-model="config.port"
        />
      </div>
      <v-divider class="my-3"></v-divider>
      <div class="d-flex align-center" style="width: 100%">
        <v-text-field 
          class="mr-2"
          style="flex: 3"
          label="URL префикс"
          color="green"
          v-model="config.url_prefix"
        />

        <v-text-field 
          class="mx-2"
          style="flex: 1"
          label="Тайм-аут подключения"
          color="green"
          type="number"
          messages="В секундах"
          v-model="config.connect_timeout"
        />
        <v-text-field 
          class="ml-2"
          style="flex: 1"
          label="Тайм-аут чтения"
          color="green"
          type="number"
          messages="В секундах"
          v-model="config.read_timeout"
        />

      </div>
      <v-divider class="my-5"></v-divider>
      <TextField 
        
        label="Предпросмотр URL" 
        disabled 
        :value="`${config.protocol}://${config.host}${config.port > 0 ? `:${+config.port}` : ''}${config.url_prefix}`" 
        copyvalue
        
      />

    
    </v-card-text>
  </v-card>
</template>

<script>
import TextField from './ui/TextField.vue'

export default {
  props:['config'],
  components:{
    TextField
  }
}
</script>